<template>
  <b-table
    responsive="xl"
    bordered
    hover
    class="bg-white"
    :items="all"
    :fields="fieldsLastPositions"
    :busy="isLoading"
  >
    <template #cell(timestamp)="{ item }">
      <div>
        {{ toBRDatetime(item.timestamp) }}
      </div>
    </template>

    <template #cell(datetime)="{ item }">
      <div>
        {{ toBRDatetime(item.datetime) }}
      </div>
    </template>

    <template #cell(latitude)="{ item }">
      <div>{{ item.latitude }}/{{ item.longitude }}</div>
    </template>

    <template #cell(ignition)="{ item }">
      <div>{{ toBooleanString(item.ignition) }}</div>
    </template>

    <template #cell(gprs)="{ item }">
      <div>{{ toBooleanString(item.gprs) }}</div>
    </template>

    <template #cell(gps)="{ item }">
      <div>{{ toBooleanString(item.gps) }}</div>
    </template>

    <template #cell(panic)="{ item }">
      <div>{{ toBooleanString(item.panic) }}</div>
    </template>

    <template #cell(out1)="{ item }">
      <div>
        {{ toBooleanString(item.out1) }}/{{ toBooleanString(item.out2) }}
      </div>
    </template>

    <template #cell(voltage)="{ item }">
      <div>{{ item.voltage }}V</div>
    </template>

    <template #cell(in1)="{ item }">
      <div>
        {{ toBooleanString(item.in1) }}/{{ toBooleanString(item.in2) }}/{{
          toBooleanString(item.in3)
        }}
      </div>
    </template>

    <template #table-busy>
      <div class="text-center my-2">
        <b-spinner class="align-middle mr-2" small />
        <strong>Carregando últimas 30 posições ...</strong>
      </div>
    </template>
  </b-table>
</template>

<script>
import { formatBoolean, formatDatetime } from "@/lib/util";
import { mapActions, mapState } from "vuex";

export default {
  name: "TablePositionsComponent",

  props: {
    vehicleId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      fieldsLastPositions: [
        {
          key: "timestamp",
          label: this.$t("server_hour"),
        },
        {
          key: "datetime",
          label: this.$t("gps_hour"),
        },
        {
          key: "ignition",
          label: this.$t("ignition"),
        },
        {
          key: "speed",
          label: this.$t("speed"),
        },
        {
          key: "odometer",
          label: this.$t("odometer"),
        },
        {
          key: "gprs",
          label: "GPRS",
        },
        {
          key: "gps",
          label: "GPS",
        },
        {
          key: "panic",
          label: this.$t("panic"),
        },
        {
          key: "out1",
          label: this.$t("outs_1/2"),
        },
        {
          key: "voltage",
          label: this.$t("voltage"),
        },
        {
          key: "temperature1",
          label: "T1",
        },
        {
          key: "latitude",
          label: this.$t("lat/lon"),
        },
        {
          key: "in1",
          label: this.$t("in_1/2/3"),
        },
      ],
    };
  },

  computed: {
    ...mapState({
      all: (state) => state.position.all,
      isLoading: (state) => state.position.isLoading,
    }),
  },

  methods: {
    ...mapActions("position", ["fetchLast30Positions", "cleanState"]),

    toBRDatetime(date) {
      return formatDatetime(date);
    },

    toBooleanString(value) {
      return formatBoolean(value);
    },
  },

  async mounted() {
    await this.fetchLast30Positions(this.vehicleId);
  },

  destroyed() {
    this.cleanState();
  },
};
</script>
